import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Drawer, SvgIcon } from '@material-ui/core';
import { ReactComponent as TurnosIcon } from './../../../assets/icons/iconoTurnos.svg';
import { ReactComponent as ContactosIcon } from './../../../assets/icons/iconoContactos.svg';
import { ReactComponent as CartillaIcon } from './../../../assets/icons/iconoCartillaGris.svg';
import { ReactComponent as FarmaciasIcon } from './../../../assets/icons/iconoFarmacias.svg';
import { ReactComponent as FormulariosIcon } from './../../../assets/icons/iconoFormularios.svg';
import { ReactComponent as HistoriaIcon } from './../../../assets/icons/iconoHistoriaGris.svg';
import { ReactComponent as AutorizacionesIcon } from './../../../assets/icons/iconoAutorizacionesGris.svg';
import { ReactComponent as CredencialIcon } from './../../../assets/icons/iconoCredencial.svg';
import { ReactComponent as ReintegrosIcon } from './../../../assets/icons/iconoReintegrosGris.svg';
import { ReactComponent as FacturacionIcon } from "./../../../assets/icons/Icono-facturacion-final.svg";
import { ReactComponent as DiscapacidadIcon} from './../../../assets/icons/iconoDiscapacidad.svg';
import { Link } from 'react-router-dom';
import { HomeOutlined } from '@material-ui/icons';

const items = [
    {
        title: "Inicio",
        icon: ()=><HomeOutlined color="primary" />,
        childrens:null,
        route: "/afiliado/inicio"
    },
    null,
    {
        title: "Credencial digital",
        icon: CredencialIcon,
        childrens:null,
        route: "/afiliado/credenciales"
    },
    null,
    {
        title: "Turnos",
        icon: TurnosIcon,
        childrens: [
            {
                title: "Sacar turnos",
                route: "/afiliado/turnos/sacar-turno"
            },
            {
                title: "Mis turnos",
                route: "/afiliado/turnos/mis-turnos"
            },
            {
                title: "Historial de atención",
                route: "/afiliado/turnos/historial-de-atencionn"
            }
        ]
    },
    null,
    {
        title: "Cartilla médica",
        icon: CartillaIcon,
        childrens:null,
        route: process.env.REACT_APP_ENVIRONMENT === 'production' ? "https://www.ospedyc.org.ar/beneficiarios/cartillamedica.aspx" : "/afiliado/cartilla",
        externo:process.env.REACT_APP_ENVIRONMENT === 'production'
    },
    null,
    {
        title: "Facturas",
        icon: FacturacionIcon,
        childrens:null,
        route:'/afiliado/facturas'
    },
    null,
    {
        title: "Formularios",
        icon: FormulariosIcon,
        childrens:null,
        route:'/afiliado/formularios'
    },
    null,
    {
        title: "Empadronamientos",
        icon: HistoriaIcon,
        childrens: null,
        disabled:true
    },
    null,
    {
        title: "Autorizaciones",
        icon: AutorizacionesIcon,
        childrens:null,
        disabled:true
    },
    null,
    {
        title: "Farmacias",
        icon: FarmaciasIcon,
        childrens:null,
        route:"/afiliado/farmacias"
    },
    null,
    {
        title: "Reintegros",
        icon: ReintegrosIcon,
        childrens:null,
        disabled:true
    },
    null,
    {
        title: "Contactos",
        icon: ContactosIcon,
        childrens:null,
        route: "/afiliado/contactos"
    },
    {
        title: "Discapacidad",
        icon: DiscapacidadIcon,
        childrens:null,
        route:"/afiliado/discapacidad"
    },
]

const useStyles = makeStyles((theme) => ({
    root: {
        // width: '100%',
        width: 250,
    },
    textItem: {
        fontWeight: "bold"
    },
    nested: {
        paddingLeft: theme.spacing(4),
      },
}));

const ItemNav = ({ title, childrens, Icon, noBold = false, route="/afiliado/inicio", disabled=false, externo=false }) => {
    const [open, setOpen] = useState(false)
    const classes=useStyles()
    const handleClick = () => {
        setOpen(!open);
    };
    if (childrens) {
        return (
            <React.Fragment key={title}>
                <ListItem button onClick={handleClick}>
                    <ListItemIcon>
                        <SvgIcon><Icon /></SvgIcon>
                    </ListItemIcon>
                    <ListItemText primaryTypographyProps={{ className: classes.textItem, color: "secondary" }} primary={title} />
                    {open ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={open} timeout="auto" unmountOnExit>
                    {
                        childrens.map(ch => (
                            <ItemNav key={title} title={ch.title} Icon={ch.icon} noBold={true} route={ch.route} />
                        ))
                    }
                </Collapse>
            </React.Fragment>
        )

    }
    return (
        <ListItem button key={title} component={externo ? 'a' : Link} to={route} href={route}>
            {
                Icon &&
                <ListItemIcon>
                    <SvgIcon><Icon /></SvgIcon>
                </ListItemIcon>
            }

            <ListItemText className={noBold ? classes.nested : {}} primaryTypographyProps={{ className: noBold || disabled ? {} : classes.textItem, color: "secondary" }} primary={title} />
        </ListItem>
    )
}

const NavBarIzquierda = ({ drawer, setDrawer }) => {
    const classes = useStyles()
    return (
        <Drawer
            role="presentation"
            open={drawer}
            onClose={() => setDrawer(false)}
            anchor="left"
        >
            <div className={classes.root}>
                <List component="nav">
                    {
                        items.map((i, index)=>{
                            if(i != null){
                                return <ItemNav key={index} disabled={i.disabled} title={i.title} Icon={i.icon} childrens={i.childrens} route={i.route} externo={i.externo} />
                            }

                            return <Divider key={index} />
                        })
                    }
                </List>
            </div>
        </Drawer>
    )
}

export default NavBarIzquierda
